/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    export interface AccountModelTargetDialogOptions {
        modelCode: string;
    }

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class AccountModelTargetDialog extends SiteEntityDialog<AccountModelTargetRow, AccountModelTargetDialogOptions> {
        protected getFormKey() { return AccountModelTargetForm.formKey; }
        protected getIdProperty() { return AccountModelTargetRow.idProperty; }
        protected getLocalTextPrefix() { return AccountModelTargetRow.localTextPrefix; }
        protected getNameProperty() { return AccountModelTargetRow.nameProperty; }
        protected getService() { return AccountModelTargetService.baseUrl; }

        protected form = new AccountModelTargetForm(this.idPrefix);

        constructor(options: AccountModelTargetDialogOptions) {
            super(options);

            this.form.LowerWarning.addValidationRule(this.uniqueName, e => {
                var m = this.form.LowerWarning.value;
                if (m != null && m < (this.form.LowerLimit.value || m))
                    return "Lower Warning has to be greater than or equal to Lower Limit!";
            });

            this.form.UpperWarning.addValidationRule(this.uniqueName, e => {
                var m = this.form.UpperWarning.value;
                if (m != null && m > (this.form.UpperLimit.value || m))
                    return "Upper Warning has to be less than or equal to Upper Limit!";
            });

            this.form.LowerLimit.addValidationRule(this.uniqueName, e => {
                var m = this.form.LowerLimit.value;
                if (m != null && m > (this.form.Target.value || 0))
                    return "Lower Limit has to be less than or equal to Target!";
            });

            this.form.UpperLimit.addValidationRule(this.uniqueName, e => {
                var m = this.form.UpperLimit.value;
                if (m != null && m < (this.form.Target.value || 0))
                    return "Upper Limit has to be greater than or equal to Target!";
            });

            var recalcTarget = this.recalcTarget.bind(this);
            this.form.Nominal.change(recalcTarget);
            AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
                this.form[t].change(recalcTarget);
            });
        }

        validateBeforeSave() {
            if (!super.validateBeforeSave())
                return false;

            this.form.Nominal.value = this.form.Nominal.value || 0;
            AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
                this.form[t].value = this.form[t].value || 0;
            });

            return true;
        }

        protected recalcTarget() {
            var target: number = null;
            if (this.form.Nominal.value != null)
                target = (target || 0) + this.form.Nominal.value;

            AccountModelTargetGrid.tiltNames(this.options.modelCode).forEach(t => {
                if (this.form[t].value != null)
                    target = (target || 0) + this.form[t].value;
            });

            this.form.Target.value = target;
        }

        protected updateInterface() {
            super.updateInterface();

            Serenity.EditorUtils.setReadOnly(this.form.Nominal, this.isViewMode() || !this.editableNominalTilt);
            for (var t of AccountModelTargetGrid.tiltNames(this.options.modelCode)) {
                Serenity.EditorUtils.setReadOnly(this.form[t], this.isViewMode() || !this.editableNominalTilt);
            }
        }

        protected getPropertyItems() {
            var items = Q.deepClone(super.getPropertyItems());

            var data = Q.getRemoteData("Data.AccountModelTargetCustomization");
            var customization = data[(this.options.modelCode || "").toLowerCase()];
            if (!customization || !customization.Fields)
                return items;

            for (var i = items.length - 1; i >= 0; i--) {
                var item = items[i];
                var field = customization.Fields[item.name.toLowerCase()];
                if (!field)
                    continue;

                if (field.Remove) {
                    items.splice(i, 1);
                    continue;
                }

                if (field.DisplayName)
                    item.title = field.DisplayName;
            }

            return items;
        }

        public editableNominalTilt: boolean;
    }
}